import enMessages from '@/languageProvider/locales/en_US';
import jaMessages from '@/languageProvider/locales/ja_JPN';

export default {
  ja: jaMessages,
  en: enMessages,
};
